import { trpc } from '@/shared/api';

/**
 * 어드민 알림 설정(notificationManagement.getSettings, 알림 설계 §6-2). 담는 것: 유형별 ON/OFF 11행, 운영자 수신자,
 * 환경 변수 기본값(QUOTE_NOTIFY_EMAIL) 설정 여부.
 */
export const useNotificationSettingsQuery = () =>
  trpc.notificationManagement.getSettings.useQuery();
